import angular from 'angular';

import template from './receipts-viewer.html';

import './receipts-viewer.less';

angular.module('myConsultApp').directive('receiptsViewer', () => {
  return {
    scope: {
      receipts: '=',
      getReceiptUrl: '=',
    },
    transclude: true,
    controller: ($scope) => {
      $scope.activeIndex = 0;
      $scope.goToIndex = (index) => {
        $scope.activeIndex = index;
      };
    },
    template,
  };
});
